import { render, staticRenderFns } from "./ConnectUs.vue?vue&type=template&id=664f9214&scoped=true&"
import script from "./ConnectUs.vue?vue&type=script&lang=js&"
export * from "./ConnectUs.vue?vue&type=script&lang=js&"
import style0 from "./ConnectUs.vue?vue&type=style&index=0&id=664f9214&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664f9214",
  null
  
)

export default component.exports